import * as React from 'react';

import { windowWrapper } from '@clubmed/utils';
import { IFRAME_CALLBACK_PAGE_ID } from 'Routes/constants';
import { STATIC_PAGE_TYPES } from 'Tracking/constants';
export const EVENT_TYPE_IFRAME = 'paymentIframe';

type IframeMessageType = {
  eventType?: string;
  callbackUrl?: string;
  paymentId?: string;
  providerResponse: unknown;
} | null;

export const IframeCallbackView = (iframeMessage: IframeMessageType) => {
  const parentWindow = windowWrapper.get('parent');
  if (parentWindow) {
    parentWindow.postMessage(iframeMessage, '*');
  }
  return null;
};
const getCMInitialProps = async ({ req }) => {
  if (req) {
    const { callbackUrl, paymentId, ...providerResponse } = req.query;
    return {
      eventType: EVENT_TYPE_IFRAME,
      callbackUrl,
      paymentId,
      providerResponse,
    };
  }
  return undefined;
};
IframeCallbackView.getCMInitialProps = getCMInitialProps;
IframeCallbackView.pageId = IFRAME_CALLBACK_PAGE_ID;
IframeCallbackView.pageType = STATIC_PAGE_TYPES.BE;
IframeCallbackView.disableFooter = true;
IframeCallbackView.disableHeader = true;
